var React = require('react');

function burger (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("rect",{"x":"4","y":"5","width":"12","height":"2"})),React.createElement("g",{"key":1},React.createElement("rect",{"x":"4","y":"11","width":"16","height":"2"})),React.createElement("g",{"key":2},React.createElement("rect",{"x":"4","y":"17","width":"12","height":"2"}))]);
}

burger.displayName = "burger";

burger.defaultProps = {"version":"1.1","id":"Design_here","x":"0px","y":"0px","viewBox":"0 0 24 24","style":{"enableBackground":"new 0 0 24 24"},"xmlSpace":"preserve"};

module.exports = burger;

burger.default = burger;
